/* Velas del Caribe: our payment page (sections/vdc-pago.liquid, /pages/pago).
   The address card is a .vdc-direccion box, so assets/vdc-direccion.js runs its sector picker and saves the cart
   attributes; this file reuses that script's state, zone logic and Storefront calls (window.vdcDireccionApi).
   Gift card: "Aplicar" sends the code to Shopify (cartGiftCardCodesUpdate); Shopify checks it and reports what it
   applies (appliedGiftCards). The full number is never stored: the field is emptied once Shopify accepts it, and
   the cart attribute "Tarjeta de regalo" holds "•••• <last4>". Choosing transfer removes the card from the cart.
   "Datos De Entrega": a gift switch (then who receives it: name and WhatsApp, used for Shopify's delivery address) and
   the address by parts. The street field "Calle principal" is the .vdc-calle input, so D.estado.calle is that street.
   Shopify gets the parts joined (address1, address2); each part is also a cart attribute (the panel reads them).
   The delivery method is chosen first: "Entrega local" (that form, blocked with a red line in a sector with no local
   delivery) or "Retiro en una oficina de DOMEX" (provincia, oficina from assets/vdc-oficinas-domex.json, who picks up
   and their WhatsApp; the office becomes the shipping address and the cart attributes of Docs/web-shopify/CONTRATO —
   Oficinas DOMEX, section 2, are sent on both confirm paths).
   "Confirmar Y Finalizar" saves the attributes, sets the cart's buyer (email, phone), its delivery address and the
   chosen delivery option, then opens /checkout with Shopify's checkout[...] pre-fill parameters (the applied gift
   card stays on the cart: proved on this store, 2026-10-21).
   Pago simulado (theme setting vdc_pago_simulado, simulation store only; the section then prints .vdc-sim-datos):
   "Tarjeta de crédito o débito" (a card form: any 12 to 19 digits, a month not past, a 3 or 4 digit code, the holder)
   and "Contra entrega" post Docs/web-shopify/CONTRATO — Pago Simulado's body to {admin}/public/pago-simulado; on
   "ok" the answer's pedido goes to sessionStorage['vdc-gracias'], the cart is cleared and /pages/gracias opens. The
   card number, expiry and code are read only to validate them: only the last 4 digits and the holder leave the page.
   Pedido de WhatsApp (admin 2.13.0, Docs/web-shopify/CONTRATO — Pago Desde WhatsApp): /pages/pago?pedido=<token> asks
   the admin for the chat's order (abrirEnlace, also with an empty cart), puts its candles and its delivery in the cart as
   an earlier visit leaves them, keeps the token and the masked email and WhatsApp for this tab (sessionStorage
   'vdc-pedido-wa') and opens the page again without the token, so it fills itself from the cart. Then the email and the
   WhatsApp stay empty with the masked values as placeholders, the note shows, and pagarSimulado sends `pedido`.
   Tarjeta de regalo of a WhatsApp link (admin 2.24.1, CONTRATO — Pago Desde WhatsApp §4, both modes): with the link's
   token and the gift card box chosen (regaloWa), "Aplicar" hides, the button reads "Pagar Con Tarjeta De Regalo" and
   pagarRegalo posts { pedido, codigo, correo, whatsapp } to {admin}/public/pago-regalo-whatsapp; the admin debits the card
   and completes the chat's order. "ok" opens /pages/gracias as the simulated payment does; a card short of the total
   shows the admin's amounts line and how to pay instead under the box; with no admin URL the button only says to pay
   by card or transfer. A visit without the token keeps the Storefront gift card above.
   "Tu Factura" (both modes): Consumidor final (the default, nothing asked) or Factura con crédito fiscal, which needs an
   RNC (9 digits) or a cédula (11) that passes the DGII check digit (rncOk, cedulaOk) and a name or razón social (it
   follows Contacto's name until typed). Both confirm paths send the attributes Factura ("Crédito fiscal"), RNC (the
   digits) and Razón social, each "" for consumidor final so an earlier choice never survives; the thank-you page gets
   the choice as sessionStorage['vdc-gracias'].factura.
   Campos obligatorios: a required field still empty (faltantes()) turns red with "Este dato es obligatorio." under it
   once the shopper leaves it or tries to confirm; the button is only aria-disabled, so a click on it while something is
   missing marks every missing field, scrolls to the first one and sends nothing.
   Tarjeta de regalo en la web (admin 2.44.0, both modes): a cart of gift cards only (2.45.0: /cart.js items with the property
   _tarjeta_regalo, which the card product's page adds to every add, snippets/vdc-regalo-para.liquid) hides
   "Datos De Entrega" whole (none of it required, validated or sent), the summary's "Envío" line, Contacto's WhatsApp hint
   (the WhatsApp becomes optional) and the Pago options "Contra entrega" and "Tarjeta de regalo", and shows a line under
   Contacto. The simulated body then has no entrega, direccion or retiro; the real confirm sets only the buyer and opens
   /checkout?checkout[email]=…. In any cart, each gift card line of the simulated body carries tarjeta: true and, when
   the page's recipient block was filled, para { correo, nombre, mensaje } from the item's properties "Para (correo)",
   "Para (nombre)" and "Mensaje"; "Contra entrega" hides
   whenever a card is in the cart (the admin makes the cards only once the order is paid). */
(function () {
  var form = document.querySelector('.vdc-pago-cols');
  var D = window.vdcDireccionApi;
  var WA = 'vdc-pedido-wa', GONE = 'Este enlace ya no sirve.'; // GONE: the admin's own line for a dead link (contract §2)
  var waDatos = document.querySelector('.vdc-pago-wa-datos'), WAT = waDatos ? JSON.parse(waDatos.textContent) : null;
  var enlace = /[?&]pedido=([A-Za-z0-9_-]{20,64})(?:&|$)/.exec(location.search), wa = null;
  if (!enlace) { try { wa = JSON.parse(sessionStorage.getItem(WA) || 'null'); } catch (err) {} }
  var olvidarWa = function () { wa = null; try { sessionStorage.removeItem(WA); } catch (err) {} };
  var waMal = function (texto) { var m = document.querySelector('.vdc-pago-wa-error'); if (m) { m.textContent = texto; m.hidden = false; } };

  /* The link's first load: the admin's pedido (GET, no cookies, 20 s at most) into the cart, then the page again. A failed
     read shows its line above the form and leaves a normal Tu Pago. */
  function abrirEnlace(token) {
    var ctl = window.AbortController ? new AbortController() : null, reloj = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    var enviar = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
    };
    fetch(String(WAT.admin || '').replace(/\/+$/, '') + '/public/pedido-whatsapp/' + token, { mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json(); }).catch(function () { return null; })
      .then(function (j) {
        clearTimeout(reloj);
        if (!j || !j.ok || !j.pedido) return waMal(j ? j.error || WAT.gone : WAT.errorRed);
        var p = j.pedido, c = p.comprador, d = p.direccion || {}, r = p.entrega && p.entrega.retiro, g = p.regalo;
        // Tu Factura as the chat left it (admin 2.20.0): crédito with its RNC (a masked cédula is left for the customer
        // to type) and razón social, else the three keys "" as for consumidor final
        var f = p.factura || {}, cr = f.tipo === 'credito';
        // every key of both delivery methods, so nothing of an earlier visit survives (the same keys datos() writes)
        var attrs = {
          Compra: [c.nombre, c.apellidos].filter(Boolean).join(' '), Entrega: r ? 'Retiro en DOMEX' : 'Entrega local',
          Regalo: g ? 'Sí' : '', Recibe: g ? g.nombre : '', 'WhatsApp de quien recibe': '',
          'Tipo de vivienda': d.tipo_vivienda || '', Edificio: d.edificio || '', Apartamento: d.apartamento || '', 'Calle principal': d.calle || '',
          'Numeración': d.numero || '', 'Calle secundaria': d.secundaria || '', Referencia: d.referencia || '', 'Dirección': d.calle || '',
          Sector: d.sector || '', 'Código postal': d.zip || '',
          'Oficina DOMEX': '', 'Oficina DOMEX id': r ? r.oficina : '', 'Oficina DOMEX dirección': '',
          Retira: r ? [r.nombre, r.apellidos].filter(Boolean).join(' ') : '', 'WhatsApp de quien retira': '', 'Tarjeta de regalo': '',
          Factura: cr ? 'Crédito fiscal' : '', RNC: cr && /^\d+$/.test(f.rnc || '') ? f.rnc : '', 'Razón social': cr ? f.razon || '' : ''
        };
        var items = p.lineas.map(function (l) { return { id: Number(String(l.variantId).split('/').pop()), quantity: l.cantidad }; });
        return enviar('/cart/clear.js', {})
          .then(function () { return enviar('/cart/add.js', { items: items }); })
          .then(function () { return enviar('/cart/update.js', { attributes: attrs }); })
          .then(function () {
            try { sessionStorage.setItem(WA, JSON.stringify({ token: p.token, correo: c.correo, whatsapp: c.whatsapp, pago: p.pago || 'tarjeta' })); } catch (err) {}
            location.replace(location.pathname);
          })
          .catch(function () { waMal(WAT.errorRed); });
      });
  }
  if (enlace && WAT) abrirEnlace(enlace[1]);
  if (!form || !D) return;
  var caja = form.querySelector('.vdc-direccion'), ds = form.dataset;
  var $ = function (s) { return form.querySelector(s); };
  var CLAVE = 'Tarjeta de regalo';
  var carrito = null, cartId = null, tarjeta = null, ocupado = false;
  var solo = false, conTarjetas = false; // the cart holds only gift cards / at least one (admin 2.44.0)
  var simDatos = form.querySelector('.vdc-sim-datos'), SIM = simDatos ? JSON.parse(simDatos.textContent) : null;
  var titularTocado = false, textoConfirmar = $('.vdc-pago-confirmar').textContent;
  var tocados = {}, intento = false; // the required fields the shopper has left, and a click on the button while not valid
  var fx = $('.vdc-pago-factura').dataset, razonTocado = !!$('.vdc-pago-razon').value.trim(), rncVisto = false;
  var dx = $('.vdc-pago-domex'), oficinas = null, cargaOficinas = null, retiraTocado = false, telRetiraTocado = !!form.querySelector('.vdc-pago-d-whatsapp').value.trim();

  var limpiar = function (s) { return String(s || '').replace(/[^a-z0-9]/gi, '').toLowerCase(); };
  var agrupar = function (s) { return s.toUpperCase().replace(/(.{4})(?=.)/g, '$1 '); };
  var rd = function (n) { return 'RD$ ' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var marcado = function (name) { var r = form.querySelector('input[name="' + name + '"]:checked'); return r ? r.value : ''; };
  var correoOk = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); };
  var digitos = function (s) { return String(s || '').replace(/\D/g, ''); };

  /* WhatsApp as Shopify wants it (E.164). A Dominican number is 10 digits (809, 829, 849); +1 is added. */
  function telefono(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (/^\+/.test(String(v).trim()) && d.length >= 10 && d.length <= 15) return '+' + d;
    if (d.length === 11 && d[0] === '1') d = d.slice(1);
    return /^8[024]9\d{7}$/.test(d) ? '+1' + d : '';
  }

  var val = function (s) { return $(s).value.trim(); };
  var esRegalo = function () { return $('.vdc-pago-es-regalo').checked; };
  var esEdificio = function () { return $('.vdc-pago-vivienda').value === 'Edificio o torre'; };
  var esSimulado = function (m) { return !!SIM && (m === 'tarjeta_sim' || m === 'contra_entrega'); };
  // admin 2.24.1: the gift card box of a WhatsApp link is paid by the admin (pagarRegalo), never applied to the cart
  var regaloWa = function () { return !!(wa && wa.token && WAT) && marcado('vdc-metodo') === 'tarjeta'; };
  var esDomex = function () { return marcado('vdc-entrega') === 'SHIPPING'; };
  var oficina = function () { var id = $('.vdc-pago-oficina').value; return id && oficinas ? oficinas.filter(function (o) { return o.id === id; })[0] || null : null; };

  /* The DOMEX office list (assets/vdc-oficinas-domex.json, Docs/web-shopify/CONTRATO — Oficinas DOMEX): fetched once,
     on page load, and the province select filled (A→Z). A failed fetch says so and may be retried by choosing DOMEX again. */
  function cargarOficinas() {
    if (!cargaOficinas) {
      cargaOficinas = fetch(dx.dataset.oficinas).then(function (r) { return r.json(); }).then(function (j) {
        oficinas = (j.oficinas || []).slice().sort(function (a, b) { return a.nombre.localeCompare(b.nombre, 'es'); });
        var provs = oficinas.map(function (o) { return o.provincia; }).filter(function (p, i, a) { return p && a.indexOf(p) === i; }).sort(function (a, b) { return a.localeCompare(b, 'es'); });
        var sel = $('.vdc-pago-provincia');
        provs.forEach(function (p) { sel.add(new Option(p, p)); });
        var antes = oficinas.filter(function (o) { return o.id === dx.dataset.oficina; })[0]; // an earlier visit's office
        if (antes) { sel.value = antes.provincia; llenarOficinas(); $('.vdc-pago-oficina').value = antes.id; }
        $('.vdc-pago-oficinas-mal').hidden = true;
        pintarOficina(); pintar();
      }).catch(function () {
        cargaOficinas = null;
        var m = $('.vdc-pago-oficinas-mal'); m.textContent = dx.dataset.error; m.hidden = false;
      });
    }
    return cargaOficinas;
  }

  /* The offices of the chosen province, "nombre · first part of direccion". */
  function llenarOficinas() {
    var sel = $('.vdc-pago-oficina'), prov = $('.vdc-pago-provincia').value;
    while (sel.options.length > 1) sel.remove(1);
    (oficinas || []).filter(function (o) { return o.provincia === prov; }).forEach(function (o) {
      sel.add(new Option(o.nombre + ' · ' + String(o.direccion || '').split(',')[0].trim(), o.id));
    });
    sel.value = ''; sel.disabled = !prov;
  }

  /* The yellow box under the office select: name, address, hours and phone, as text. */
  function pintarOficina() {
    var o = oficina(), c = $('.vdc-pago-oficina-caja');
    c.hidden = !o; c.textContent = '';
    if (!o) return;
    var b = document.createElement('b'); b.textContent = 'DOMEX ' + o.nombre; c.appendChild(b);
    c.appendChild(document.createTextNode(o.direccion || ''));
    var pie = [o.horario, o.telefono ? dx.dataset.tel + ' ' + o.telefono : ''].filter(Boolean).join(' · ');
    if (pie) { c.appendChild(document.createElement('br')); c.appendChild(document.createTextNode(pie)); }
  }

  /* The simulated card's rules: 12 to 19 digits; "MM / AA" for this month or a later one; 3 or 4 digits; a holder. */
  var simOk = {
    numero: function (v) { var n = digitos(v).length; return n >= 12 && n <= 19; },
    fecha: function (v) {
      var m = /^(\d{2}) \/ (\d{2})$/.exec(v), hoy = new Date();
      if (!m || +m[1] < 1 || +m[1] > 12) return false;
      return (2000 + +m[2]) * 12 + +m[1] >= hoy.getFullYear() * 12 + hoy.getMonth() + 1;
    },
    codigo: function (v) { return /^\d{3,4}$/.test(v); },
    titular: function (v) { return !!v; }
  };
  var tarjetaSimOk = function () { return Object.keys(simOk).every(function (k) { return simOk[k](val('.vdc-sim-' + k)); }); };

  /* Tu Factura. The DGII check digit, on the digit string. RNC (9 digits): weights 7 9 8 6 5 4 3 2 on the first 8,
     r = sum % 11, check 2 for r 0, 1 for r 1, else 11 - r. Cédula (11 digits): weights 1 2 1 2… on the first 10, a
     product over 9 minus 9, check (10 - sum % 10) % 10. */
  function rncOk(d) {
    if (!/^\d{9}$/.test(d)) return false;
    var w = [7, 9, 8, 6, 5, 4, 3, 2], s = 0;
    for (var i = 0; i < 8; i++) s += w[i] * +d[i];
    var r = s % 11;
    return (r === 0 ? 2 : r === 1 ? 1 : 11 - r) === +d[8];
  }
  function cedulaOk(d) {
    if (!/^\d{11}$/.test(d)) return false;
    var s = 0;
    for (var i = 0; i < 10; i++) { var p = +d[i] * (i % 2 ? 2 : 1); s += p > 9 ? p - 9 : p; }
    return (10 - s % 10) % 10 === +d[10];
  }
  var numeroOk = function (d) { return d.length === 9 ? rncOk(d) : cedulaOk(d); };
  /* "401-50625-4" once 9 digits, "001-1234567-8" once 11, the plain digits in between. */
  var guiones = function (d) { return d.length === 9 ? d.slice(0, 3) + '-' + d.slice(3, 8) + '-' + d.slice(8) : d.length === 11 ? d.slice(0, 3) + '-' + d.slice(3, 10) + '-' + d.slice(10) : d; };
  var esCredito = function () { return marcado('vdc-factura') === 'credito'; };
  var rncDigitos = function () { return digitos($('.vdc-pago-rnc').value); };
  /* The three attributes, always sent ("" for consumidor final, so an earlier choice is cleared). */
  function facturaAttrs() {
    var c = esCredito();
    return { Factura: c ? 'Crédito fiscal' : '', RNC: c ? rncDigitos() : '', 'Razón social': c ? val('.vdc-pago-razon') : '' };
  }
  /* The thank-you page's Factura cell: "Consumidor final", or "Crédito fiscal · RNC 401-50625-4 · <razón social>". */
  function facturaTexto() {
    if (!esCredito()) return fx.consumo;
    var d = rncDigitos();
    return [fx.credito, (d.length === 11 ? fx.cedula : fx.rnc) + ' ' + guiones(d), val('.vdc-pago-razon')].join(' · ');
  }
  /* The panel opens with crédito fiscal; the green mark when the number passes; the red line once the shopper leaves
     a non-empty field that fails, or as soon as 11 digits fail (never while a number is still being typed, so a cédula
     passing 9 digits does not flash red). */
  function pintarFactura() {
    var d = rncDigitos(), ok = numeroOk(d), mal = !!d && !ok && (rncVisto || d.length === 11);
    $('.vdc-pago-factura-sub').hidden = !esCredito();
    if (!razonTocado) $('.vdc-pago-razon').value = [val('.vdc-pago-nombre'), val('.vdc-pago-apellidos')].filter(Boolean).join(' ');
    $('.vdc-pago-rnc-ok').hidden = !ok;
    $('.vdc-pago-rnc-mal').hidden = !mal;
    $('.vdc-pago-rnc').setAttribute('aria-invalid', mal ? 'true' : 'false');
  }

  /* The delivery method comes first. Entrega local: today's form (gift on: the recipient block shows, the buyer's name
     stays in Contacto, always required; building fields only for "Edificio o torre"). Retiro en DOMEX: the local form
     hides and provincia, oficina and who picks up show. A hidden field is never required, validated or sent. */
  function pintarCampos() {
    var dm = esDomex() && !solo, r = esRegalo() && !dm && !solo, ed = esEdificio() && !dm && !solo;
    $('.vdc-pago-local').hidden = dm; dx.hidden = !dm;
    $('.vdc-pago-recibe').hidden = !esRegalo();
    $('.vdc-pago-obsequio').classList.toggle('vdc-pago-sel', esRegalo());
    $('.vdc-pago-edificio').hidden = !esEdificio();
    ['.vdc-pago-r-nombre', '.vdc-pago-r-apellidos', '.vdc-pago-r-whatsapp'].forEach(function (c) { $(c).required = r; });
    ['.vdc-pago-edificio-nombre', '.vdc-pago-apto'].forEach(function (c) { $(c).required = ed; });
    ['.vdc-calle', '.vdc-pago-numero'].forEach(function (c) { $(c).required = !dm && !solo; });
    ['.vdc-pago-provincia', '.vdc-pago-oficina', '.vdc-pago-d-nombre', '.vdc-pago-d-apellidos', '.vdc-pago-d-whatsapp'].forEach(function (c) { $(c).required = dm; });
    if (dm && !oficinas) cargarOficinas();
  }

  /* Gift cards (admin 2.44.0): what a cards-only cart hides and shows, and a payment the cart can no longer use is moved
     to the box's first option (and an applied gift card taken off: a card does not pay a card). */
  function pintarTarjetas() {
    caja.hidden = solo;
    $('.vdc-pago-envio').parentNode.hidden = solo;
    $('.vdc-pago-tarjetas-correo').hidden = !solo;
    var contra = form.querySelector('[data-pago="contra_entrega"]'), m = marcado('vdc-metodo');
    if (contra) contra.hidden = conTarjetas;
    form.querySelector('[data-pago="tarjeta"]').hidden = solo;
    if ((m === 'contra_entrega' && conTarjetas) || (m === 'tarjeta' && solo)) form.querySelector('input[name="vdc-metodo"][value="' + (SIM ? 'tarjeta_sim' : 'transferencia') + '"]').checked = true;
    if (solo && tarjeta) quitarTarjeta();
    pintarCampos();
  }

  /* The street line Shopify gets (address1) and the second line (address2: building and landmark). A cross street
     typed with its own "esq." is not given a second one. */
  function lineas1y2() {
    var e = D.estado.elegido, sec = val('.vdc-pago-secundaria'), ref = val('.vdc-pago-referencia');
    var calle = [D.estado.calle.trim(), val('.vdc-pago-numero')].filter(Boolean).join(' ');
    if (sec) calle += (/^esq\b/i.test(sec) ? ' ' : ' esq. ') + sec;
    return [
      [calle, e && e[1] ? e[0] : ''].filter(Boolean).join(', '),
      [esEdificio() ? val('.vdc-pago-edificio-nombre') + ', apto ' + val('.vdc-pago-apto') : '', ref ? 'Ref: ' + ref : ''].filter(Boolean).join(' · ')
    ];
  }

  function zonaActual() { var e = D.estado.elegido; return e ? D.zona(caja, e[2]) : ''; }
  var hayLocal = function () { var z = zonaActual(); return z === 'gratis' || z === 'local'; };
  /* The delivery price in RD$, or null while it is not known (local delivery before a served sector is picked). */
  function envioRD(tipo) {
    if (tipo === 'LOCAL') return !hayLocal() ? null : zonaActual() === 'gratis' ? 0 : Number(ds.localRd);
    return tipo === 'SHIPPING' ? Number(ds.paisRd) : null;
  }

  /* Both delivery options always show. "Entrega local" is priced from the sector's zone ("—" before a sector, or in a
     sector with no local delivery, where the red line asks for DOMEX and the button stays disabled). */
  function pintarEntrega() {
    var z = zonaActual();
    $('[data-entrega="LOCAL"] .vdc-pago-opcion-precio').textContent = z === 'gratis' ? ds.gratis : z === 'local' ? caja.dataset.precioLocal : '—';
    $('.vdc-pago-sin-local').hidden = esDomex() || !D.estado.elegido || hayLocal();
    pintar();
  }

  /* The summary, the card lines and the button. */
  function pintar() {
    form.querySelectorAll('.vdc-pago-opcion').forEach(function (o) { o.classList.toggle('vdc-pago-sel', o.querySelector('input').checked); });
    var tipo = marcado('vdc-entrega'), metodo = marcado('vdc-metodo');
    $('.vdc-pago-sub').hidden = metodo !== 'tarjeta';
    if (!retiraTocado) { $('.vdc-pago-d-nombre').value = val('.vdc-pago-nombre'); $('.vdc-pago-d-apellidos').value = val('.vdc-pago-apellidos'); }
    if (!telRetiraTocado) $('.vdc-pago-d-whatsapp').value = val('.vdc-pago-whatsapp');
    if (SIM) {
      form.querySelectorAll('.vdc-sim-panel').forEach(function (p) { p.hidden = p.dataset.panel !== metodo; });
      if (!titularTocado) $('.vdc-sim-titular').value = [val('.vdc-pago-nombre'), val('.vdc-pago-apellidos')].filter(Boolean).join(' ');
    }
    var boton = $('.vdc-pago-confirmar');
    boton.textContent = regaloWa() ? (WAT.admin ? WAT.pagarRegalo : WAT.sinAdmin)
      : SIM && metodo === 'tarjeta_sim' ? SIM.pagar : SIM && metodo === 'contra_entrega' ? SIM.confirmarPedido : textoConfirmar;
    boton.nextElementSibling.hidden = esSimulado(metodo) || regaloWa(); // "pasas a la pantalla segura de Shopify" is not true for these
    $('.vdc-pago-aplicar-btn').hidden = regaloWa();
    var envio = solo ? 0 : envioRD(tipo), sub = carrito ? carrito.total_price / 100 : 0, total = sub + (envio || 0);
    var e = D.estado.elegido, o = oficina(), lugar = esDomex() ? [ds.domex].concat(o ? [o.nombre] : []).join(' · ') : e ? e[0] : '';
    $('.vdc-pago-subtotal').textContent = carrito ? rd(sub) : '';
    $('.vdc-pago-envio-lugar').textContent = lugar ? '(' + lugar + ')' : '';
    $('.vdc-pago-envio').textContent = envio === null ? '—' : envio ? rd(envio) : ds.gratis;
    var para = $('.vdc-pago-para'), quien = [val('.vdc-pago-r-nombre'), val('.vdc-pago-r-apellidos')].filter(Boolean).join(' ');
    para.hidden = !(esRegalo() && !esDomex() && !solo && quien);
    para.firstChild.textContent = ds.regaloPara + ' ' + quien;
    var t = metodo === 'tarjeta' && tarjeta, usa = t ? Math.min(t.saldo, total) : 0, linea = $('.vdc-pago-regalo');
    linea.hidden = !t;
    if (t) {
      linea.children[0].textContent = ds.tarjeta + ' •••• ' + t.last.toUpperCase();
      linea.children[1].textContent = '− ' + rd(usa);
      var ok = $('.vdc-pago-tarjeta-ok');
      ok.textContent = '✓ ' + ds.ok + ' · ' + ds.saldo + ' ' + rd(t.saldo) + ' · ' + (usa >= total ? ds.cubre : ds.faltan.replace('%m', rd(total - usa)));
      ok.hidden = false;
    } else {
      $('.vdc-pago-tarjeta-ok').hidden = true;
    }
    $('.vdc-pago-total-monto').textContent = rd(Math.max(total - usa, 0));
    $('.vdc-pago-queda').textContent = t ? ds.queda.replace('%m', rd(t.saldo - usa)) : '';
    pintarFactura();
    var listo = valido(), falta = marcar(), linea = $('.vdc-pago-falta');
    $('.vdc-pago-confirmar').setAttribute('aria-disabled', String(!listo || ocupado || !carrito));
    linea.hidden = listo;
    linea.textContent = falta.length === 1 ? ds.faltaUno : falta.length ? ds.faltaVarios.replace('%n', falta.length) : ds.falta;
  }

  /* The required fields: Contacto's four always (its WhatsApp only for local delivery, as in valido()), the others while
     pintarCampos() makes them required (the sector with the street: a typed sector counts only once picked from the list). */
  var OBLIGA = ['nombre', 'apellidos', 'correo', 'whatsapp', 'r-nombre', 'r-apellidos', 'r-whatsapp', 'edificio-nombre', 'apto',
    'calle', 'numero', 'sector', 'provincia', 'oficina', 'd-nombre', 'd-apellidos', 'd-whatsapp'];
  var CONTACTO = ['nombre', 'apellidos', 'correo', 'whatsapp'];
  var campo = function (k) { return $(k === 'calle' || k === 'sector' ? '.vdc-' + k : '.vdc-pago-' + k); };
  function faltantes() {
    var local = marcado('vdc-entrega') === 'LOCAL' && !solo;
    return OBLIGA.filter(function (k) {
      var pide = k === 'whatsapp' ? local : CONTACTO.indexOf(k) >= 0 || campo(k === 'sector' ? 'calle' : k).required;
      return pide && (k === 'sector' ? !D.estado.elegido : !campo(k).value.trim());
    });
  }
  /* Paints a missing field (red box, its "obligatorio" line) once it was left or the button was clicked; returns the list. */
  function marcar() {
    var falta = faltantes();
    OBLIGA.forEach(function (k) {
      var si = falta.indexOf(k) >= 0 && (intento || !!tocados[k]);
      campo(k).classList.toggle('vdc-pago-campo-falta', si);
      $('[data-obliga="' + k + '"]').hidden = !si;
    });
    return falta;
  }

  /* What must be true before "Confirmar": email, the buyer's name, a valid WhatsApp for local delivery (or a typed one),
     a payment choice (with the card applied when it is the gift card), and the chosen delivery's own fields. Local: for
     a gift the recipient's name and a valid WhatsApp, Calle principal and Numeración (building and apartment for
     "Edificio o torre"), a sector from the list that gets local delivery. DOMEX: an office, who picks up and their
     valid WhatsApp. */
  function valido() {
    var w = $('.vdc-pago-whatsapp').value.trim(), tipo = marcado('vdc-entrega'), metodo = marcado('vdc-metodo');
    var whatsappOk = w ? !!telefono(w) : solo || tipo !== 'LOCAL';
    $('.vdc-pago-whatsapp-ayuda').hidden = solo || tipo !== 'LOCAL';
    var comprador = correoOk($('.vdc-pago-correo').value) && !!val('.vdc-pago-nombre') && !!val('.vdc-pago-apellidos') && whatsappOk;
    var entrega = solo || (tipo === 'SHIPPING'
      ? !!oficina() && !!val('.vdc-pago-d-nombre') && !!val('.vdc-pago-d-apellidos') && !!telefono(val('.vdc-pago-d-whatsapp'))
      : tipo === 'LOCAL' && (!esRegalo() || (!!val('.vdc-pago-r-nombre') && !!val('.vdc-pago-r-apellidos') && !!telefono(val('.vdc-pago-r-whatsapp'))))
        && (!esEdificio() || (!!val('.vdc-pago-edificio-nombre') && !!val('.vdc-pago-apto')))
        && !!val('.vdc-pago-numero') && !!D.estado.calle.trim() && !!D.estado.elegido && hayLocal());
    var factura = !esCredito() || (numeroOk(rncDigitos()) && !!val('.vdc-pago-razon'));
    // a WhatsApp link's gift card: its 16 letters typed (the admin checks the card), and an admin to send them to
    if (regaloWa()) return comprador && entrega && factura && !!WAT.admin && limpiar(val('.vdc-pago-tarjeta')).length === 16;
    return comprador && entrega && factura
      && (metodo === 'transferencia' || (metodo === 'tarjeta' && !!tarjeta)
        || (esSimulado(metodo) && (metodo === 'contra_entrega' || tarjetaSimOk())));
  }

  /* A field's "check this" line shows once the shopper leaves it. */
  function revisar(campo) {
    var v = $('.vdc-pago-' + campo).value.trim(), mal = false;
    if (campo === 'correo') mal = !!v && !correoOk(v);
    if (/whatsapp$/.test(campo)) mal = !!v && !telefono(v);
    $('.vdc-pago-mal[data-para="' + campo + '"]').hidden = !mal;
  }
  function revisarSim(k) {
    var v = val('.vdc-sim-' + k);
    $('.vdc-pago-mal[data-para="sim-' + k + '"]').hidden = k === 'titular' ? !!v : !v || simOk[k](v);
  }

  function lineas() {
    $('.vdc-pago-lineas').innerHTML = carrito.items.map(function (i) {
      var img = i.image ? '<img src="' + esc(i.image) + (i.image.indexOf('?') < 0 ? '?' : '&') + 'width=112" alt="" width="56" height="56" loading="lazy">' : '';
      return '<li class="vdc-pago-suma vdc-pago-linea"><span>' + img + esc(i.product_title) + ' × ' + i.quantity + '</span><b>' + rd(i.final_line_price / 100) + '</b></li>';
    }).join('');
  }

  var GIFT = 'appliedGiftCards { lastCharacters amountUsed { amount } balance { amount } }';
  function leerTarjeta(c, last) {
    var g = (c && c.appliedGiftCards || []).filter(function (x) { return !last || x.lastCharacters.toLowerCase() === last; })[0];
    return g ? { last: g.lastCharacters.toLowerCase(), saldo: Number(g.amountUsed.amount) + Number(g.balance.amount) } : null;
  }

  function avisoTarjeta(texto) { var m = $('.vdc-pago-tarjeta-mal'); m.textContent = texto || ''; m.hidden = !texto; }

  function guardarTarjeta(v) {
    var attrs = {}; attrs[CLAVE] = v;
    return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* "Aplicar": Shopify checks the code. A code it does not accept comes back with no applied card (and, for some
     cases, a user error), so the answer is read off appliedGiftCards. */
  function aplicar() {
    var code = limpiar($('.vdc-pago-tarjeta').value);
    if (code.length !== 16) return avisoTarjeta(ds.corta);
    if (tarjeta && tarjeta.last === code.slice(-4)) { $('.vdc-pago-tarjeta').value = ''; return avisoTarjeta(ds.ya); }
    var btn = $('.vdc-pago-aplicar-btn');
    btn.disabled = true; avisoTarjeta('');
    D.gql('mutation($id: ID!, $c: [String!]!) { cartGiftCardCodesUpdate(cartId: $id, giftCardCodes: $c) { cart { ' + GIFT + ' } userErrors { code message } } }', { id: cartId, c: [code] })
      .then(function (j) {
        var r = j.data && j.data.cartGiftCardCodesUpdate;
        if (!r) throw new Error('sin respuesta');
        var t = leerTarjeta(r.cart, code.slice(-4)), err = (r.userErrors || [])[0];
        tarjeta = t && t.saldo > 0 ? t : null;
        if (!tarjeta) {
          avisoTarjeta(t || (err && /balance|saldo|depleted|empty/i.test(err.code + ' ' + err.message)) ? ds.sinSaldo
            : err && /already|ya /i.test(err.code + ' ' + err.message) ? ds.ya : ds.invalida);
          if (t) quitarTarjeta();
        } else {
          $('.vdc-pago-tarjeta').value = '';
          guardarTarjeta('•••• ' + tarjeta.last);
        }
        pintar();
      })
      .catch(function () { avisoTarjeta(ds.error); })
      .then(function () { btn.disabled = false; });
  }

  function quitarTarjeta() {
    tarjeta = null; pintar();
    return D.gql('mutation($id: ID!) { cartGiftCardCodesUpdate(cartId: $id, giftCardCodes: []) { userErrors { message } } }', { id: cartId })
      .then(function () { return guardarTarjeta(''); }).catch(function () {});
  }

  /* What both confirm paths send: the delivery name and phone (the recipient's for a gift, who picks up for DOMEX), the
     buyer's email and phone, the address (the two lines, or the DOMEX office), and the cart attributes. Every key of
     both methods on every confirm ("" when it does not apply), so an earlier visit's value never survives. */
  var VACIO_LOCAL = ['Regalo', 'Recibe', 'WhatsApp de quien recibe', 'Tipo de vivienda', 'Edificio', 'Apartamento', 'Calle principal',
    'Numeración', 'Calle secundaria', 'Referencia', 'Dirección', 'Sector', 'Código postal'];
  var VACIO_DOMEX = ['Oficina DOMEX', 'Oficina DOMEX id', 'Oficina DOMEX dirección', 'Retira', 'WhatsApp de quien retira'];
  var vacios = function (claves) { var a = {}; claves.forEach(function (k) { a[k] = ''; }); return a; };
  function datos() {
    var compra = val('.vdc-pago-nombre') + ' ' + val('.vdc-pago-apellidos'), tel = telefono($('.vdc-pago-whatsapp').value);
    if (esDomex()) {
      // Retiro en DOMEX (CONTRATO — Oficinas DOMEX, section 2): the office is the address, who picks up is its name.
      var o = oficina(), dn = val('.vdc-pago-d-nombre'), da = val('.vdc-pago-d-apellidos'), dt = telefono(val('.vdc-pago-d-whatsapp'));
      return {
        oficina: o, nombre: dn, apellidos: da, correo: val('.vdc-pago-correo'), tel: tel, telEntrega: dt,
        attrs: Object.assign(vacios(VACIO_LOCAL), facturaAttrs(), {
          Compra: compra, Entrega: 'Retiro en DOMEX', 'Oficina DOMEX': o.nombre, 'Oficina DOMEX id': o.id,
          'Oficina DOMEX dirección': o.direccion || '', Retira: dn + ' ' + da, 'WhatsApp de quien retira': dt
        })
      };
    }
    var regalo = esRegalo(), edificio = esEdificio(), l = lineas1y2();
    var nombre = val(regalo ? '.vdc-pago-r-nombre' : '.vdc-pago-nombre'), apellidos = val(regalo ? '.vdc-pago-r-apellidos' : '.vdc-pago-apellidos');
    var telRecibe = regalo ? telefono(val('.vdc-pago-r-whatsapp')) : '';
    return {
      e: D.estado.elegido, l: l, nombre: nombre, apellidos: apellidos, correo: val('.vdc-pago-correo'), tel: tel, telEntrega: regalo ? telRecibe : tel,
      attrs: Object.assign(vacios(VACIO_DOMEX), facturaAttrs(), {
        Compra: compra, // the buyer, gift or not (both required)
        Entrega: 'Entrega local',
        Regalo: regalo ? 'Sí' : '', Recibe: regalo ? nombre + ' ' + apellidos : '', 'WhatsApp de quien recibe': telRecibe,
        'Tipo de vivienda': $('.vdc-pago-vivienda').value,
        Edificio: edificio ? val('.vdc-pago-edificio-nombre') : '', Apartamento: edificio ? val('.vdc-pago-apto') : '',
        'Calle principal': D.estado.calle.trim(), 'Numeración': val('.vdc-pago-numero'), 'Calle secundaria': val('.vdc-pago-secundaria'),
        Referencia: val('.vdc-pago-referencia'), 'Dirección': l[0]
      })
    };
  }

  /* The address lines both paths send: the local address (zip from the sector), or the DOMEX office ("DOMEX <nombre>",
     its address, city and province, no zip). */
  function direccionDe(d) {
    if (d.oficina) return { address1: 'DOMEX ' + d.oficina.nombre, address2: d.oficina.direccion || '', city: d.oficina.ciudad || '', province: d.oficina.provincia || '' };
    return { address1: d.l[0], address2: d.l[1], city: d.e[1] || d.e[0], zip: d.e[2] };
  }

  /* "Confirmar Y Finalizar": attributes, buyer, address and delivery option on the cart, then Shopify's checkout
     filled in. If the Storefront API fails or hangs, the checkout still opens filled in (D.luego: at most 8 s).
     The two simulated methods go to pagarSimulado instead. */
  function confirmar(ev) {
    ev.preventDefault();
    if (ocupado || !carrito) return;
    if (!valido()) {
      // nothing is sent: every missing field turns red and the first one comes into view with the caret in it
      intento = true; pintar();
      var primero = form.querySelector('.vdc-pago-campo-falta');
      if (primero) { primero.scrollIntoView({ block: 'center', behavior: 'smooth' }); primero.focus({ preventScroll: true }); }
      return;
    }
    if (regaloWa()) return pagarRegalo();
    if (esSimulado(marcado('vdc-metodo'))) return pagarSimulado(marcado('vdc-metodo'));
    olvidarWa(); // Shopify's checkout makes its own order: the link's token has nothing to do there
    ocupado = true; pintar();
    var b = $('.vdc-pago-confirmar'); b.setAttribute('aria-busy', 'true');
    if (solo) return confirmarTarjetas();
    var d = datos(), a = direccionDe(d), correo = d.correo, tel = d.tel;
    var direccion = { firstName: d.nombre, lastName: d.apellidos, address1: a.address1, city: a.city, countryCode: 'DO' };
    ['address2', 'zip'].forEach(function (k) { if (a[k]) direccion[k] = a[k]; });
    if (d.telEntrega) direccion.phone = d.telEntrega;
    var comprador = { email: correo, countryCode: 'DO' };
    if (tel) comprador.phone = tel;
    var q = new URLSearchParams();
    q.set('checkout[email]', correo);
    var s = { first_name: d.nombre, last_name: d.apellidos, address1: a.address1, address2: a.address2, city: a.city, province: a.province, zip: a.zip, country: 'DO', phone: d.telEntrega };
    Object.keys(s).forEach(function (k) { if (s[k]) q.set('checkout[shipping_address][' + k + ']', s[k]); });
    var attrs = d.attrs;
    attrs[CLAVE] = tarjeta && marcado('vdc-metodo') === 'tarjeta' ? '•••• ' + tarjeta.last : '';
    D.marca(true);
    var cadena = D.guardar(attrs)
      .then(function () {
        return D.gql('mutation($id: ID!, $b: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { userErrors { message } } }', { id: cartId, b: comprador });
      })
      .then(function () { return D.direccionDelCarrito(direccion, marcado('vdc-entrega')); });
    D.luego(cadena, function () { location.href = '/checkout?' + q.toString(); }, 8000); // seven calls: about 3 s on a good line
  }

  /* Gift cards only, Shopify's checkout (admin 2.44.0): the attributes (every delivery key "", so none of an earlier visit
     survives), the buyer (email, phone if typed), no delivery address, then /checkout with the email; Shopify handles a
     gift-card-only checkout itself. */
  function confirmarTarjetas() {
    var correo = val('.vdc-pago-correo'), tel = telefono($('.vdc-pago-whatsapp').value), comprador = { email: correo, countryCode: 'DO' };
    if (tel) comprador.phone = tel;
    var attrs = Object.assign(vacios(VACIO_LOCAL), vacios(VACIO_DOMEX), facturaAttrs(), { Compra: val('.vdc-pago-nombre') + ' ' + val('.vdc-pago-apellidos'), Entrega: '' });
    attrs[CLAVE] = '';
    var q = new URLSearchParams();
    q.set('checkout[email]', correo);
    var cadena = D.guardar(attrs).then(function () {
      return D.gql('mutation($id: ID!, $b: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { userErrors { message } } }', { id: cartId, b: comprador });
    });
    D.luego(cadena, function () { location.href = '/checkout?' + q.toString(); }, 8000);
  }

  /* 2.45.0: a gift card line is one the card product's page marked (property _tarjeta_regalo), never Shopify's gift_card */
  function esTarjeta(i) { return !!(i.properties && i.properties._tarjeta_regalo); }

  /* A cart line as the simulated body sends it; a gift card's also says so and carries who receives it, when the page's
     recipient block was filled (its properties "Para (correo)", "Para (nombre)", "Mensaje"). */
  function lineaDe(i) {
    var l = { variantId: 'gid://shopify/ProductVariant/' + i.variant_id, cantidad: i.quantity };
    if (!esTarjeta(i)) return l;
    l.tarjeta = true;
    var pr = i.properties || {}, para = { correo: String(pr['Para (correo)'] || '').trim(), nombre: String(pr['Para (nombre)'] || '').trim(), mensaje: String(pr.Mensaje || '').trim() };
    Object.keys(para).forEach(function (k) { if (!para[k]) delete para[k]; });
    if (Object.keys(para).length) l.para = para;
    return l;
  }

  /* Pago simulado: the contract's body to {admin}/public/pago-simulado (no cookies, 20 s at most) behind the
     "Procesando tu pago…" overlay (2 s at least). On "ok": the pedido (plus the buyer's WhatsApp, for the thank-you
     page) in sessionStorage, the cart emptied, /pages/gracias. Otherwise the answer's error line, or the network
     line, under the options; nothing typed is lost. */
  /* A POST of the page's own to the admin (no cookies, 20 s at most) that lasts 2 s at least, behind the overlay: the
     answer's JSON, or null on a network failure. */
  function alAdmin(base, ruta, cuerpo) {
    var ctl = window.AbortController ? new AbortController() : null, reloj = setTimeout(function () { if (ctl) ctl.abort(); }, 20000);
    var pedido = fetch(String(base).replace(/\/+$/, '') + ruta, {
      method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo), signal: ctl ? ctl.signal : undefined
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
    return Promise.all([pedido, new Promise(function (listo) { setTimeout(listo, 2000); })]).then(function (x) { clearTimeout(reloj); return x[0]; });
  }
  /* A paid order: its pedido (plus the buyer's WhatsApp and the invoice) for the thank-you page, the cart emptied, /pages/gracias. */
  function alGracias(d, pedido) {
    olvidarWa();
    try { sessionStorage.setItem('vdc-gracias', JSON.stringify(Object.assign({ whatsapp: d.tel, factura: facturaTexto() }, pedido))); } catch (err) {}
    return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).catch(function () {})
      .then(function () { location.href = '/pages/gracias'; });
  }

  function pagarSimulado(metodo) {
    ocupado = true; pintar();
    var aviso = $('.vdc-sim-error'), espera = $('.vdc-sim-espera');
    aviso.hidden = true; espera.hidden = false;
    var d = datos(), e = d.e, a = solo ? {} : direccionDe(d), tipo = marcado('vdc-entrega'), envio = solo ? 0 : envioRD(tipo);
    var atributos = Object.assign(e ? { 'Dirección': D.estado.calle, Sector: D.nombre(e), 'Código postal': e[2] } : {}, d.attrs);
    Object.keys(atributos).forEach(function (k) { if (!String(atributos[k]).trim()) delete atributos[k]; });
    var direccion = { nombre: d.nombre + ' ' + d.apellidos, whatsapp: d.telEntrega };
    Object.keys(a).forEach(function (k) { if (a[k]) direccion[k] = a[k]; });
    var cuerpo = {
      pago: metodo === 'tarjeta_sim' ? 'tarjeta' : 'contra_entrega',
      correo: d.correo, whatsapp: d.tel,
      comprador: { nombre: val('.vdc-pago-nombre'), apellidos: val('.vdc-pago-apellidos') },
      lineas: carrito.items.map(lineaDe),
      entrega: { tipo: tipo, precio: envio }, direccion: direccion, atributos: atributos,
      total: Math.round(carrito.total_price + envio * 100) / 100
    };
    if (solo) {
      // gift cards only: nothing travels, so no delivery, no address and only the buyer's own attributes (Compra, Tu Factura)
      delete cuerpo.entrega; delete cuerpo.direccion;
      cuerpo.atributos = { Compra: atributos.Compra };
      ['Factura', 'RNC', 'Razón social'].forEach(function (k) { if (atributos[k]) cuerpo.atributos[k] = atributos[k]; });
    }
    if (d.oficina && !solo) cuerpo.retiro = { oficina: d.oficina.id, nombre: d.nombre, apellidos: d.apellidos, whatsapp: d.telEntrega };
    if (wa && wa.token) cuerpo.pedido = wa.token; // the chat's order this page was opened for (CONTRATO — Pago Simulado §5)
    if (metodo === 'tarjeta_sim') cuerpo.tarjeta = { ultimos4: digitos(val('.vdc-sim-numero')).slice(-4), titular: val('.vdc-sim-titular') };
    alAdmin(SIM.admin, '/public/pago-simulado', cuerpo).then(function (j) {
      if (j && j.ok && j.pedido) return alGracias(d, j.pedido);
      if (j && j.error === GONE) olvidarWa(); // a dead link: the page pays as a normal Tu Pago from now on
      espera.hidden = true; ocupado = false;
      aviso.textContent = (j && j.error) || SIM.errorRed; aviso.hidden = false;
      pintar();
    });
  }

  /* admin 2.24.1, a WhatsApp link's gift card (CONTRATO — Pago Desde WhatsApp §4): the code, the retyped email and WhatsApp
     and the token to {admin}/public/pago-regalo-whatsapp behind the overlay. "ok": /pages/gracias. A card short of the
     total (`falta`): the admin's amounts line and how to pay instead, under the box; any other answer its line; the code
     stays typed. */
  function pagarRegalo() {
    ocupado = true; avisoTarjeta(''); pintar();
    var espera = $('.vdc-sim-espera') || $('.vdc-pago-espera'), d = datos();
    espera.hidden = false;
    alAdmin(WAT.admin, '/public/pago-regalo-whatsapp', { pedido: wa.token, codigo: limpiar(val('.vdc-pago-tarjeta')), correo: d.correo, whatsapp: d.tel || val('.vdc-pago-whatsapp') })
      .then(function (j) {
        if (j && j.ok && j.pedido) return alGracias(d, j.pedido);
        if (j && j.error === GONE) olvidarWa();
        espera.hidden = true; ocupado = false;
        avisoTarjeta(!j ? ds.error : j.falta ? j.error + ' ' + WAT.restoRegalo : j.error || ds.error);
        pintar();
      });
  }

  /* Formats a field in place (limpia: what is kept of it; groups of 4), keeping the caret after the same character. */
  function agruparCampo(inp, limpia) {
    var antes = limpia(inp.value.slice(0, inp.selectionStart)).length, v = limpia(inp.value);
    inp.value = agrupar(v);
    var pos = antes + Math.floor(Math.max(antes - 1, 0) / 4);
    if (antes && antes % 4 === 0 && antes < v.length) pos++;
    inp.setSelectionRange(pos, pos);
  }

  /* The gift card field (letters and digits) and the simulated card's fields: the number in groups of 4 (19 digits at
     most), the expiry as "MM / AA", the code digits only; the holder follows Contacto's name until it is typed. */
  form.addEventListener('input', function (ev) {
    var inp = ev.target, c = inp.classList;
    if (c.contains('vdc-pago-tarjeta')) {
      agruparCampo(inp, limpiar);
      avisoTarjeta('');
    }
    if (c.contains('vdc-sim-numero')) agruparCampo(inp, function (s) { return digitos(s).slice(0, 19); });
    if (c.contains('vdc-sim-fecha')) { var f = digitos(inp.value).slice(0, 4); inp.value = f.length > 2 ? f.slice(0, 2) + ' / ' + f.slice(2) : f; }
    if (c.contains('vdc-sim-codigo')) inp.value = digitos(inp.value).slice(0, 4);
    if (c.contains('vdc-sim-titular')) titularTocado = !!inp.value.trim();
    if (c.contains('vdc-pago-rnc')) { var g = guiones(digitos(inp.value).slice(0, 11)); if (inp.value !== g) inp.value = g; } // a phone types at the end
    if (c.contains('vdc-pago-razon')) razonTocado = !!inp.value.trim();
    if (c.contains('vdc-pago-d-nombre') || c.contains('vdc-pago-d-apellidos')) retiraTocado = true;
    if (c.contains('vdc-pago-d-whatsapp')) telRetiraTocado = true;
    pintar();
  });
  form.addEventListener('change', function (ev) {
    var n = ev.target.name;
    if (n === 'vdc-entrega' || ev.target.classList.contains('vdc-pago-es-regalo') || ev.target.classList.contains('vdc-pago-vivienda')) pintarCampos();
    if (n === 'vdc-entrega') pintarEntrega();
    if (ev.target.classList.contains('vdc-pago-provincia')) llenarOficinas();
    if (ev.target.classList.contains('vdc-pago-provincia') || ev.target.classList.contains('vdc-pago-oficina')) pintarOficina();
    if (n === 'vdc-metodo' && ev.target.value === 'transferencia') { avisoTarjeta(''); if (tarjeta) quitarTarjeta(); }
    if (n === 'vdc-metodo' && ev.target.value === 'tarjeta') setTimeout(function () { $('.vdc-pago-tarjeta').focus(); }, 0);
    if (n === 'vdc-metodo' && SIM) $('.vdc-sim-error').hidden = true;
    pintar();
  });
  form.addEventListener('focusout', function (ev) {
    var c = ev.target.classList;
    if (c.contains('vdc-pago-correo')) revisar('correo');
    if (c.contains('vdc-pago-whatsapp')) revisar('whatsapp');
    if (c.contains('vdc-pago-r-whatsapp')) revisar('r-whatsapp');
    if (c.contains('vdc-pago-d-whatsapp')) revisar('d-whatsapp');
    ['numero', 'fecha', 'codigo', 'titular'].forEach(function (k) { if (c.contains('vdc-sim-' + k)) revisarSim(k); });
    if (c.contains('vdc-pago-rnc')) { rncVisto = !!rncDigitos(); pintar(); }
    var k = OBLIGA.filter(function (x) { return campo(x) === ev.target; })[0];
    if (k) { tocados[k] = true; pintar(); }
  });
  form.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ev.target.classList.contains('vdc-pago-tarjeta')) { ev.preventDefault(); if (!regaloWa()) aplicar(); }
  });
  $('.vdc-pago-aplicar-btn').addEventListener('click', aplicar);
  form.addEventListener('submit', confirmar);
  document.addEventListener('vdc-direccion', pintarEntrega);

  /* An earlier visit's picker (the Retira attribute, split at its first space) wins over Contacto's name. */
  var retira = dx.dataset.retira.trim(), corteR = retira.indexOf(' ');
  if (retira) { retiraTocado = true; $('.vdc-pago-d-nombre').value = corteR < 0 ? retira : retira.slice(0, corteR); $('.vdc-pago-d-apellidos').value = corteR < 0 ? '' : retira.slice(corteR + 1); }
  $('.vdc-pago-rnc').value = guiones(rncDigitos().slice(0, 11)); // an earlier visit's RNC attribute is the digits
  pintarCampos();
  cargarOficinas(); // prefetched on load, so choosing DOMEX shows the provinces at once

  /* First paint: the cart's lines, and what the Storefront cart already holds (a card applied before, the buyer
     and the name and WhatsApp given on an earlier visit). The delivery address carries the name of who receives it:
     the recipient's when the gift switch came back on (the Recibe attribute fills Nombre whole only when the cart has
     no address), else the buyer's. After a DOMEX pickup the address carries the picker's name and phone, so none of it
     is read (the picker comes back from the Retira and "WhatsApp de quien retira" attributes). The buyer's name otherwise
     comes from the Compra attribute, split at its first space (joined again on confirm, so the stored value never changes). */
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
    carrito = c; cartId = 'gid://shopify/Cart/' + c.token;
    conTarjetas = c.items.some(esTarjeta);
    solo = c.items.length > 0 && c.items.every(esTarjeta);
    lineas(); pintarTarjetas(); pintarEntrega();
    return D.gql('query($id: ID!) { cart(id: $id) { ' + GIFT + ' buyerIdentity { email phone } delivery { addresses { address { ... on CartDeliveryAddress { firstName lastName phone } } } } } }', { id: cartId });
  }).then(function (j) {
    var c = j && j.data && j.data.cart;
    if (!c) return;
    var fija = function (sel, v) { var i = $(sel); if (v && !i.value) i.value = v; };
    fija('.vdc-pago-correo', c.buyerIdentity && c.buyerIdentity.email);
    var a = esDomex() ? {} : (c.delivery && c.delivery.addresses || []).map(function (x) { return x.address; }).filter(Boolean)[0] || {};
    var regalo = esRegalo(), recibe = $('.vdc-pago-recibe').dataset.recibe;
    fija('.vdc-pago-whatsapp', (c.buyerIdentity && c.buyerIdentity.phone) || (regalo ? '' : a.phone)); // checkout may drop the buyer's phone
    fija(regalo ? '.vdc-pago-r-nombre' : '.vdc-pago-nombre', a.firstName); fija(regalo ? '.vdc-pago-r-apellidos' : '.vdc-pago-apellidos', a.lastName);
    if (regalo && !a.firstName) fija('.vdc-pago-r-nombre', recibe);
    var compra = $('.vdc-pago-propio').dataset.compra.trim(), corte = compra.indexOf(' ');
    if (compra) { fija('.vdc-pago-nombre', corte < 0 ? compra : compra.slice(0, corte)); fija('.vdc-pago-apellidos', corte < 0 ? '' : compra.slice(corte + 1)); }
    tarjeta = leerTarjeta(c);
    var primero = SIM ? 'tarjeta_sim' : 'transferencia'; // the first option of the box
    if (tarjeta || !marcado('vdc-metodo')) form.querySelector('input[name="vdc-metodo"][value="' + (tarjeta ? 'tarjeta' : primero) + '"]').checked = true;
    if (wa) {
      // a WhatsApp order: the customer types the email and the WhatsApp (shown masked), the box's first way to pay
      ['correo', 'whatsapp'].forEach(function (k) { var i = $('.vdc-pago-' + k); i.value = ''; i.placeholder = wa[k] || ''; i.required = true; });
      var nota = document.querySelector('.vdc-pago-wa-nota');
      if (nota) nota.hidden = false;
      // admin 2.21.1: a gift card order opens on the gift card box, a card order on the box's first way to pay
      form.querySelector(wa.pago === 'tarjeta_regalo' ? 'input[name="vdc-metodo"][value="tarjeta"]' : 'input[name="vdc-metodo"]').checked = true;
      // crédito fiscal stays chosen when the link's RNC was a masked cédula (the cart has Factura but no RNC to prefill)
      if ((c.attributes || {}).Factura === 'Crédito fiscal') form.querySelector('input[name="vdc-factura"][value="credito"]').checked = true;
    }
    pintarTarjetas(); // an applied card or a link's choice may have picked an option the cart cannot use
    pintar();
  }).catch(function () { pintar(); });
})();
